import { useEffect } from "react";
import Lenis from "lenis";
import Header from "./Header";
import Footer from "./Footer";
import CtaBand from "./CtaBand";
import CookieConsent from "./CookieConsent";

export default function Layout({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-sand" data-testid="layout">
      <Header />
      <main data-testid="contenido-principal">{children}</main>
      <CtaBand />
      <Footer />
      <CookieConsent />
    </div>
  );
}